import { type LucideIcon } from 'lucide-react';
import { getTextColorHex } from '../utils/color-contrast';

interface TagChipProps {
  label: string;
  icon?: LucideIcon;
  variant?: 'default' | 'main';
  color?: string;
  disabled?: boolean;
}

export function TagChip({
  label,
  icon: Icon,
  variant = 'default',
  color,
  disabled = false,
}: TagChipProps) {
  const backgroundColor = color || (variant === 'main' ? '#e1f433' : '#3b0b86');
  const textColor = getTextColorHex(backgroundColor);

  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-opacity"
      style={{
        backgroundColor,
        color: textColor,
        fontFamily: 'var(--font-primary)',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {Icon && <Icon className="h-3.5 w-3.5" />}
      <span>{label}</span>
    </span>
  );
}

interface MainTagChipProps {
  label: string;
  icon?: LucideIcon;
  color?: string;
  disabled?: boolean;
}

export function MainTagChip({ label, icon, color, disabled }: MainTagChipProps) {
  return <TagChip label={label} icon={icon} variant="main" color={color} disabled={disabled} />;
}
